
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:550px;">
    <form #projectForm="ngForm" (ngSubmit)="save()">
      <div class="modal-header">
        <h4 class="modal-title">Create a Project</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <form [formGroup]="form">
          <div class="row">
            <div class="form-group col">
              <label class="required" for="nameField">Project Name</label>
              <input class="form-control" id="nameField" type="text" formControlName="projectName" name="name" maxlength="100" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label>Region</label>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="region" formControlName="region" value="AMS" autoLinkToLabel>
                <label class="form-check-label">AMS  - Americas</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="region" formControlName="region" value="APJ" autoLinkToLabel>
                <label class="form-check-label">APJ  - Asia, Pacific and Japan</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="region" formControlName="region" value="EMEA" autoLinkToLabel>
                <label class="form-check-label">EMEA - Europe, Middle East and Africa</label>
              </div>
            </div>
            <div class="form-group col">
              <label>Target System</label>
              <div class="form-check">
                <input class="form-check-input" type="radio" [checked]="true" name="targetSystem" formControlName="targetSystem" value="legacy" autoLinkToLabel>
                <label class="form-check-label">Legacy</label>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="submit">Save</button>
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>